import styled from 'styled-components';

export const StatusButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;